<template>
  <div class="spec">
    <h2>Будние дни</h2>
    <div class="block">
      <div class="pair" v-for="p in daily" :key="'daily-' + p[0]">
        <div class="p">{{ p[0] }}</div>
        <div class="se">{{ p[1] }}</div>
        <div class="chill">{{ p[2] }} — {{ p[3] }}</div>
        <div class="se">{{ p[4] }}</div>
      </div>
    </div>
    <h2>Выходные дни</h2>
    <div class="block">
      <div class="pair" v-for="p in weekends" :key="'weekends-' + p[0]">
        <div class="p">{{ p[0] }}</div>
        <div class="se">{{ p[1] }}</div>
        <div class="chill">{{ p[2] }} — {{ p[3] }}</div>
        <div class="se">{{ p[4] }}</div>
      </div>
    </div>
    <h2>Предпраздничные дни</h2>
    <div class="block">
      <div class="pair" v-for="p in holydays" :key="'holydays-' + p[0]">
        <div class="p">{{ p[0] }}</div>
        <div class="se">{{ p[1] }}</div>
        <div class="chill" v-if='p[2]'>{{ p[2] }} — {{ p[3] }}</div>
        <div class="chill" v-else><span class='inv'>00:00</span> — <span class='inv'>00:00</span></div>
        <div class="se">{{ p[4] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      daily: [
        ["1", "08:30", "09:15", "09:20", "10:05"],
        ["2", "10:15", "11:00", "11:05", "11:50"],
        ["3", "12:35", "13:20", "13:25", "14:10"],
        ["4", "14:20", "15:05", "15:10", "15:55"],
        ["5", "16:05", "16:50", "16:55", "17:40"],
        ["6", "17:50", "18:35", "18:40", "19:25"],
      ],
      holydays: [
        ["1", "08:30", "09:15", "09:20", "10:05"],
        ["2", "10:15", "11:00", "11:05", "11:50"],
        ["3", "12:00", "12:45", "12:55", "13:40"],
        ["4", "13:50", "", "", "14:50"],
        ["5", "15:00", "", "", "16:00"],
      ],
      weekends: [
        ["1", "08:30", "09:15", "09:20", "10:05"],
        ["2", "10:15", "11:00", "11:05", "11:50"],
        ["3", "12:00", "12:45", "12:55", "13:40"],
        ["4", "13:50", "14:35", "14:40", "15:25"],
        ["5", "15:35", "16:20", "16:25", "17:10"],
        ["6", "17:20", "18:05", "18:10", "18:55"],
      ],
    };
  },
};
</script>

<style scoped lang='stylus'>
.spec {
  // padding: 0 24px;
}

.block {
  // border-bottom: 1px solid var(--border);
  padding: 18px 0;
  background var(--block-bg)
  border-radius: 24px;
  // border-radius: 16px;
  // border: 1px solid var(--border)
  margin: 0 0 48px;
}

.pair {
  display: flex;
  font-size: 18px;
  justify-content: space-evenly
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  margin: 0 10px 8px;

  .p {
    opacity: 0.5;
  }

  .chill {
    opacity: 0.5;
    font-size: 10px;
    text-align: center;
  }

  div {
    // margin-right: 32px;
    display: table-cell;
    // padding: 0 20px;
  }
}
.inv {
  opacity 0;
}

h2 {
  font-size: 14px;
  padding: 10px 20px 16px;
  margin: 0;
  // border-bottom 1px solid var(--border)
  text-align center
}

@media only screen and (max-width: 350px) {
  .spec {
    padding: 0
  }
}
</style>